import { styled } from "@mui/material/styles";
import { Box } from "@mui/material";

export const ScheduleModalContainer = styled(Box)(() => ({
  width: "100%",
  display: "flex",
  flexDirection: "column",
}));

export const SectionTitle = styled(Box)(() => ({
  fontFamily: "Manrope, sans-serif",
  fontSize: 14,
  fontWeight: 700,
  lineHeight: "20px",
  letterSpacing: "0.25px",
  color: "#344054",
}));

export const FormRow = styled(Box)(() => ({
  display: "flex",
  gap: 12,
  width: "100%",
}));

